import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { CourseService } from 'app/core/services/course.service';
import { Course } from 'app/shared/models/course';

@Injectable()
export class CoursesResolver implements Resolve<Course[]> {
  constructor(private courseService: CourseService, private router: Router) {}

  resolve(): Promise<any> {
    return this.courseService.getCourses().catch(error => {
      this.router.navigate(['/error']);
      return Promise.reject(error);
    });
  }
}
